import {React, useEffect, useState, useContext} from 'react'
import RuralAndUrbanConsumerRetailPriceData from '../../../../Components/RuralAndUrbanConsumerRetailPriceData'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import {shortMonthToFull,handleUserLevelAccessPermissions,getAllYears,validateRoles,validateMonthYears} from '../../../../Custom/Custom'
import messages from '../.././../../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';

function RuralConsumerRetailPrice() {

  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [blockCode, setBlockCode] = useState('')
  const [years, setYears] = useState([]);
  const [months, setMonth] = useState([]);
  const [districtCode, setDistrictCode] = useState('');
  const [yearName, setYearName] = useState('');
  const [monthName, setMonthName] = useState('');
  const [ruralConsumerPrice, setRuralConsumerPrice] = useState([]);
  const [payload, setPayload] = useState([]);
  const [isDivision, setIsDivision ] = useState(false);
  const [isDistrict, setIsDistrict ] = useState(false);
  const [buttonAccess, setButtonAccess] =  useState({userLevel:'',roles:'',isVisible:false});
  const token = useContext(MyContextProvider).token;
  const decode_token =jwtDecode(token)
  const navigate = useNavigate();
  // Check if user has DISPRI role
  const isDISPRI = decode_token?.id?.ROLE_CODE?.split('|').includes('DISPRI') || false;
  // Check if user has HQPRI/HQADM/HQAdmin role
  const isHQUser = decode_token?.id?.ROLE_CODE?.split('|').some(role => ['HQPRI', 'HQADM', 'HQAdmin'].includes(role)) || false;
  const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }


 useEffect(() => {
        
        const level =  handleUserLevelAccessPermissions(decode_token);
        setButtonAccess(level)
  
        // get District By Division ID
        const getDistrictListByDivision = async () => {
          try {
            const response =  await axios.post(
              `${API_URL}api/geDistrictListByDivisionId`,
              { division_Id: decode_token.id.USER_LEVEL_LOCATION }, config );
            const allDistrict = response.data;
           
           if (allDistrict.status) {
                setDistrictList(allDistrict.data);
                showLoading(false);
            }
            } catch (error) {
            console.error(error);
            showLoading(false);
            }
          }
  
  
  
         // All district list
          const getDistrictList = async () => {
          
              try {
                  const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
                  const allDistrict = response.data;
          
                  if (allDistrict.status) {
                      setDistrictList(allDistrict.data);
                      showLoading(false);
                  }
              } catch (error) {
              console.error(error);
              showLoading(false);
              }
          };
  
        // Set district list for district-level user
        const setDistrictForDistrictLevel = () => {
          const districtCode = decode_token.id.USER_LEVEL_LOCATION;
          const districtName = decode_token.id.LOCATION_NAME;

          const singleDistrict = [{
            DISTRICT_CODE: districtCode,
            DISTRICT_NAME: districtName
          }];

          setDistrictList(singleDistrict);
          setDistrictCode(districtCode);
          setIsDistrict(true);
          getBlockListByDistrictId(districtCode);
          showLoading(false);
        };

        //Get all Months data    
       const getMonthsList = (e) => { 
          showLoading(true)
              axios
                .get(`${API_URL}api/graph/getMonths/2019`, config)
                .then((res) => {
                  let monthDataResponse = res.data;
                  if (monthDataResponse.status) {
                    setMonth(monthDataResponse.data);
                    showLoading(false)
                  }
                })
                .catch((err) => {
                  console.error(err);
                 showLoading(false);
                });
            }
  
  
        const getYearList =()=>{
              setYears(getAllYears());
            }
  
        const pageLoadRuralConsumerPrice=()=>{
          showLoading(true);
            axios
            .get(`${API_URL}api/consumerRetail/getRuralConsumerPriceInputForm`, config)
            .then((res) => {
              let allData = res.data;
            if (allData.status) {
                setRuralConsumerPrice(allData.data[0].GroupCodes);
               setTimeout(()=>(showLoading(false)),3000)
              }
            }).catch((err)=>{
                console.log(err)
                showLoading(false);
            } );
        }
  
  
       
   const userRole = async () => {
          showLoading(true)
          try {
            const role = await validateRoles(decode_token)
            if (role) {
              
                  pageLoadRuralConsumerPrice(); 
                  getYearList();
                  getMonthsList();
        
                  if(level.userLevel==='DIVISION LEVEL' && level.roles.includes('DIVADM')){
                    getDistrictListByDivision()
                    setIsDivision(true)
                  }else if(level.userLevel==='DISTRICT LEVEL'){
                    setDistrictForDistrictLevel()
                  }else{
                      getDistrictList()
                }
  
           }else {
          
              alert("You are not an authorized user to capture the data for Pricing");
              navigate("/dashboard");
            }
          } catch (error) {
            console.log(error);
            showLoading(false)
          }
        }
    
    
        userRole();
  
         
      },[]);


    const handleDropdownChange=(e)=>{
        
      switch(e.target.name){
        case 'district_name':
              setDistrictCode(e.target.value)
              getBlockListByDistrictId(e.target.value)
              setMonthName('')
              setYearName('')
              
        break;
        case 'block_name':
          setBlockCode(e.target.value)
          // Reset only entry fields (Current Price, Remarks, Reject Status) when Block changes; form stays visible
          if (ruralConsumerPrice && ruralConsumerPrice.length > 0) {
            const updated = ruralConsumerPrice.map(group => ({
              ...group,
              subGroups: (group.subGroups || []).map(subGroup => ({
                ...subGroup,
                itemCodes: (subGroup.itemCodes || []).map(item => ({
                  ...item,
                  currentPrice: '',
                  remark: '',
                  statusFlag: item.statusFlag === '6' ? '' : item.statusFlag
                }))
              }))
            }));
            setRuralConsumerPrice(updated);
          }
          // For DISPRI role: Reset Month and Year when Block changes
          if(isDISPRI){
            setMonthName('')
            setYearName('')
          }
          // For HQPRI/HQADM/HQAdmin role: Reset Month and Year when Block changes
          if(isHQUser){
            setMonthName('')
            setYearName('')
          }
       break;
        case 'month_name':
              setMonthName(e.target.value)
              setYearName('')
              // Note: Block Name is NOT reset when Month changes - it should remain selected
        break;
        case 'year_name':

            if(!validateMonthYears(e.target.value,monthName)){
              setMonthName('')
              setYearName('')
              // For DISPRI role: Reset Block when validation fails
              if(isDISPRI){
                setBlockCode('')
              }
              return;
            }
        
            if(districtCode===''){
              toast.error(messages.DISTRICT_MSG, messages.COLOR_RED);
              setYearName('')
              // For DISPRI role: Reset Block when district is not selected
              if(isDISPRI){
                setBlockCode('')
              }
              return;
            }
        
          if(monthName===''){
            toast.error(messages.MONTH_MSG, messages.COLOR_RED);
            setYearName('')
            // For DISPRI role: Reset Block when month is not selected
            if(isDISPRI){
              setBlockCode('')
            }
              return;
          }
          
          // For DISPRI role: Block Name is mandatory
          if(isDISPRI && blockCode===''){
            toast.error(messages.BLOCK_MSG, messages.COLOR_RED);
            setYearName('')
            return;
          }
          
            setYearName(e.target.value)
            let postData={
              "district_code": districtCode,
              "block_code": blockCode,
              "month_name": monthName,
              "year_name": e.target.value
            }
            onChangeRuralConsumerPriceData(postData)

                
        break;
        default:
          console.log("switch case are not match");
      break;

      }
    }


         // Block list
  const getBlockListByDistrictId = async (district_id) => {
  
          try {
              const response = await axios.post(`${API_URL}api/geBlockListByDistrictId`,{
                district_Id: district_id
              }, config);
              const block = response.data;
              if (block.status) {
                  setBlockList(block.data);
                  setBlockCode('')
                  showLoading(false);
               }
          } catch (error) {
          console.error(error);
          showLoading(false);
          }
      };





  const onChangeRuralConsumerPriceData= async (postData)=>{
    showLoading(true)
    
        try {
        
          const response = await axios.post(`${API_URL}api/consumerRetail/getRuralConsumerPriceInputFormData`, postData,config);
          if(response.data.status){
           
            setRuralConsumerPrice(response.data.data[0].GroupCodes);
            setPayload(response.data.data[1].payload)
            showLoading(false)
          }
        
        } catch (error) {
          console.error('Error posting data:', error);
          showLoading(false)
        }

  }
  const resetMothAndYearField=()=>{
    setMonthName('')
    setYearName('')
    setBlockCode('')
    if(!isDistrict){
      setDistrictCode('')
    }
  
  }

  const storedLanguage = localStorage.getItem('language');

  return (
    <>
   
    <ToastContainer/>
    <GlobalLoading />
      <div className="container-fluid py-3">
       <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
         <div className="row align-items-center">
             <h4 className="page_heading">
             {storedLanguage === 'hi' ? titlesData.hi.RURAL_CONSUMER_PRICE_INPUT_FORM : titlesData.en.RURAL_CONSUMER_PRICE_INPUT_FORM}</h4>
             
             <div className="row align-items-center">
             {isDivision &&
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION} </label>
                    <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                  </div>
             }
            {isDistrict &&
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT} </label>
                    <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                 </div>
            }
            {!isDistrict &&
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT}</label>
                    <select
                     name="district_name"
                     id="district_name"
                     className="form-select"
                    onChange={handleDropdownChange}
                    value={districtCode}
                   >
                  <option value="" disabled>Select District</option>
                  {districtList &&
                    districtList
                      .slice()
                      .sort((a, b) => a.DISTRICT_NAME.localeCompare(b.DISTRICT_NAME))
                      .map((ele, index) => (
                        <option key={index} value={ele.DISTRICT_CODE}>
                          {ele.DISTRICT_NAME}
                        </option>
                      ))}
                </select>
                </div>
            }
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? titlesData.hi.BLOCK_NAME : titlesData.en.BLOCK_NAME}</label>
                     <select
                      name="block_name"
                      id="block_name"
                      className="form-select"
                     onChange={handleDropdownChange}
                     value={blockCode}
                    >
                   <option value="" >Select Block</option>
                   {blockList &&
                     blockList.map((ele, index) => (
                         <option key={index} value={ele.BLOCK_CODE}>
                           {ele.BLOCK_NAME}
                         </option>
                       ))}
                 </select>
                 </div>
 
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                 <label>{storedLanguage === 'hi' ? titlesData.hi.MONTH : titlesData.en.MONTH}</label>
                  <select  name="month_name"
                   className="form-select"  
                   onChange={handleDropdownChange} 
                   value={monthName}
                   >
                     <option value="" disabled>Select Month</option>
                       {months && months.map((ele, i) => (
                         <option key={i} value={ele.MONTH}>
                         {shortMonthToFull(ele.MONTH)}
                         </option>
                       ))}
                 </select>
                 </div>
 
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                 <label>{storedLanguage === 'hi' ? titlesData.hi.CURRENT_YEAR : titlesData.en.CURRENT_YEAR}</label>
                     <select  name="year_name" 
                      className="form-select" 
                      onChange={handleDropdownChange}  
                       value={yearName} >
                         <option value="" disabled>Select Year</option>
                         {years && years.map((ele, index) => (
                           <option key={index} value={ele}>
                           {ele}
                           </option>
                         )) }
                   </select>
                 </div>
             </div>
         </div>
       </div>
     </div>
 
     <div className="card mx-3 mb-3">
         {
            ruralConsumerPrice.length > 0 && 
            <RuralAndUrbanConsumerRetailPriceData 
              type="rural" 
              payload={payload} 
              districtCode={districtCode} 
              config={config} 
              resetMothAndYearField={resetMothAndYearField}  
              userInfoObject={buttonAccess}  
              yearName={yearName} 
              monthName={monthName} 
              blockCode={blockCode} 
              urbanAndRuralCommonItemPrice={ruralConsumerPrice}
              url="RuralConsumerRetailPriceInputFormDataSaveToDB"
              isReadOnlyMode={isHQUser && blockCode === ''}
            />
         }
    </div>
     </div>
    
     </>
  )
}

export default RuralConsumerRetailPrice